const renderSettings = () => <></>;

export default renderSettings;
